var React = require('react');

function LogoMail (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"nonzero"},[React.createElement("path",{"fill":"#393939","d":"M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M13 14.5L20.5 8h-15l7.5 6.5zm-2.026-.72L13 15.443l1.994-1.663L20.5 18.5h-15l5.474-4.72zM5 18V8.5l5.5 4.75L5 18zm16 0V8.5l-5.5 4.75L21 18z","key":1})]));
}

LogoMail.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = LogoMail;

LogoMail.default = LogoMail;
